var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent_note"},[_vm._l((_vm.data.note),function(k){return (_vm.data.note)?_c('img',{attrs:{"src":k}}):_vm._e()}),_c('p',{on:{"click":_vm.go_native}},[_vm._v("进入下一步学习")]),(_vm.loadingLock)?_c('lesson_loading',{attrs:{"status":_vm.status}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }